import { CountryIsoCode } from 'shared/data/webApp/v2';

// TODO: this is temp solution, later we will receive countries from BE
// This constant array is placed here and not in constants file to prevent circular dependencies
const restrictedCountries = [
    // Restricted countries by CurrencyCloud
    CountryIsoCode.BY,
    CountryIsoCode.CU,
    CountryIsoCode.IR,
    CountryIsoCode.KZ,
    CountryIsoCode.LY,
    CountryIsoCode.MM,
    CountryIsoCode.KP,
    CountryIsoCode.RU,
    CountryIsoCode.SS,
    CountryIsoCode.SD,
    CountryIsoCode.SY,
    CountryIsoCode.VE,
    // Not actual countries like some dependant territories or not/partially recognized
    CountryIsoCode.AQ,
    CountryIsoCode.AX,
    CountryIsoCode.BQ,
    CountryIsoCode.BV,
    CountryIsoCode.CC,
    CountryIsoCode.CX,
    CountryIsoCode.EH,
    CountryIsoCode.GS,
    CountryIsoCode.HM,
    CountryIsoCode.IM,
    CountryIsoCode.PN,
    CountryIsoCode.SJ,
    CountryIsoCode.SX,
    CountryIsoCode.TF,
    CountryIsoCode.UM,
] as const;

export const isRestrictedCountry = (country: CountryIsoCode): country is (typeof restrictedCountries)[number] =>
    restrictedCountries.findIndex((item) => item === country) !== -1;
